import { render, staticRenderFns } from "./MediaWithBgColor.vue?vue&type=template&id=6e164cd2&"
import script from "./MediaWithBgColor.vue?vue&type=script&lang=js&"
export * from "./MediaWithBgColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports